<template>
    <div class="container-fluid">
        <template v-if="status===201">
            <h4 class="m-3">Добавление SKU товара</h4>
            <product-skus></product-skus>
            <el-button class="m-3" type="primary" @click="$router.push('/products')">OK</el-button>
        </template>
        <template v-else>
            <div v-for="attribute in errors" v-bind:key="attribute" class="alert alert-danger">
                <div v-for="error in attribute" v-bind:key="error">
                    {{ error }}
                </div>
            </div>
            <h4 class="m-3">Добавление товара</h4>
            <el-form ref="form" :model="form" label-position="left" label-width="250px" id="uploadForm"
                     name="uploadForm" enctype="multipart/form-data">
                <el-form-item label="Название">
                    <el-input v-model="form.title"></el-input>
                </el-form-item>
                <el-form-item label="Slug">
                    <el-input v-model="form.slug"></el-input>
                </el-form-item>
                <el-form-item label="Описание">
                    <el-input type="textarea" :rows="3" v-model="form.description"></el-input>
                </el-form-item>
                <el-form-item label="Артикул">
                    <el-input v-model="form.article"></el-input>
                </el-form-item>
                <el-form-item label="Производитель">
                    <el-select
                    v-model="form.maker"
                    filterable
                    allow-create
                    default-first-option
                    no-data-text="Нет данных"
                    placeholder="Выберите производителя">
                        <el-option
                                v-for="item in makers"
                                :key="item.id"
                                :label="item.title"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Тип товара">
                    <el-select
                    v-model="form.type"
                    filterable
                    allow-create
                    default-first-option
                    placeholder="Выберите тип товара"
                    no-data-text="Нет данных">
                        <el-option
                                v-for="item in types"
                                :key="item.id"
                                :label="item.title"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label-width="250px" label="Добавить в рекомендуемые?">
                    <el-radio v-model="form.recommended" :label="true">Да</el-radio>
                    <el-radio v-model="form.recommended" :label="false">Нет</el-radio>
                </el-form-item>
                <el-form-item label-width="250px" label="Добавить в хиты?">
                    <el-radio v-model="form.hit" :label="true">Да</el-radio>
                    <el-radio v-model="form.hit" :label="false">Нет</el-radio>
                </el-form-item>
                <el-form-item label-width="250px" label="Добавить в новинки?">
                    <el-radio v-model="form.new" :label="true">Да</el-radio>
                    <el-radio v-model="form.new" :label="false">Нет</el-radio>
                </el-form-item>
                <el-form-item label-width="250px" label="Действует скидка по дисконтным картам?">
                    <el-radio v-model="form.discount_work" :label="true">Да</el-radio>
                    <el-radio v-model="form.discount_work" :label="false">Нет</el-radio>
                </el-form-item>
                <hr>
                <h6>Единица измерения</h6>
                <el-form-item label="Название">
                    <el-input v-model="form.unit.title"></el-input>
                </el-form-item>
                <el-form-item label="Короткое название">
                    <el-input v-model="form.unit.short"></el-input>
                </el-form-item>
                <el-form-item label="Винительный падеж">
                    <el-input v-model="form.unit.acc_case"></el-input>
                </el-form-item>
                <hr>
                <el-form-item label="Сортировка">
                    <el-input v-model="form.sort"></el-input>
                </el-form-item>
                <el-form-item label="Активность">
                    <el-checkbox v-model="form.activity"></el-checkbox>
                </el-form-item>
                <el-form-item label="Изображениея">
                    <el-upload
                    action=""
                    list-type="picture"
                    :auto-upload="false"
                    :on-change="handleChange"
                    >
                        <el-button size="small" type="primary">Добавить Изображение</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item  label="Разделы каталога">
                  <el-select
                  v-model="form.section"
                  filterable
                  multiple
                  placeholder="Выберите разделы"
                  no-data-text="Нет данных">
                    <el-option
                      v-for="item in getSections"
                      :key="item.id"
                      :label="item.path"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="create">Добавить</el-button>
                    <el-button @click="back">Отмена</el-button>
                </el-form-item>

            </el-form>
        </template>
    </div>
</template>

<script>
import axios from "axios";
import ProductSkus from "@/components/ProductSkus/ProductSkus";

export default {
    name: "ProductCreate",
    components: {ProductSkus},
    data() {
        return {
            form: {
                slug: '',
                title: '',
                description: '',
                article: '',
                section: '',
                recommended: false,
                maker: '',
                type: '',
                sort: 1,
                activity: true,
                hit: false,
                new: false,
                discount_work: true,
                unit: {
                    title: '',
                    acc_case: '',
                    short: ''
                }
            },
            files: [],
            makers: [],
            status: 0,
            dialogVisible: false,
            skus: [],
            errors: [],
            types: []

        }
    },
    computed: {
        skuForms() {
            return this.$store.getters.skuForm;
        },
    },
    mounted() {
        this.getMakers();
        this.getTypes();
    },
    methods: {
        back() {
            this.$router.push('/products');
        },
        getTypes() {
            axios.get('/api/admin/product/types/').then((response) => {
                this.types = response.data;
            })
        },
        getMakers() {
            axios.get('/api/promo-action/makers/').then((response) => {
                this.makers = response.data.data;
            })
        },
        create() {
            const data = new FormData(document.getElementById('uploadForm'));

            if (this.files.length > 0) {
                for (var i = 0; i < this.files.length; i++) {
                    let file = this.files[i];

                    data.append('img[' + i + ']', file);
                }
            }


            data.append('title', this.form.title);
            data.append('slug', this.form.slug);
            data.append('description', this.form.description);
            data.append('article', this.form.article);
            data.append('section', this.form.section);
            data.append('recommended', this.form.recommended);
            data.append('hit', this.form.hit);
            data.append('new', this.form.new);
            data.append('discount_work', this.form.discount_work);
            data.append('maker', this.form.maker);
            data.append('type', this.form.type);
            data.append('activity', this.form.activity);
            data.append('sort', this.form.sort);
            data.append('unit', JSON.stringify(this.form.unit));

            axios.post('/api/admin/product/create', data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }).then((response) => {
                this.status = response.status;

                this.$store.commit('productId', response.data);


            }).catch((errors) => {

                if (errors.response.status === 401) {
                    this.$router.push('/login');
                }

                console.log(errors.response.data.errors);
                this.errors = errors.response.data.errors;
            });
        },
        deleteFile(index) {
            this.files.splice(index, 1);
            this.getImagePreviews();
        },
        getImagePreviews() {
            for (let i = 0; i < this.files.length; i++) {

                if (/\.(jpe?g|png|gif)$/i.test(this.files[i].name)) {

                    let reader = new FileReader();
                    reader.addEventListener("load", function () {
                        this.$refs['image' + parseInt(i)][0].src = reader.result;
                    }.bind(this), false);
                    reader.readAsDataURL(this.files[i]);
                }
            }
        },
        addFiles() {
            this.$refs.files.click();
        },

        handleFilesUpload() {
            let uploadedFiles = this.$refs.files.files;
            for (var i = 0; i < uploadedFiles.length; i++) {
                this.files.push(uploadedFiles[i]);
            }
            this.getImagePreviews();
        },

    }
}
</script>

<style scoped>

</style>